<template>
  <div class="row">
    <div class="col-12">
      <div class="m-portlet">

        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                Top client managers
              </h3>
            </div>
          </div>
        </div>

        <div class="m-portlet__body">
          <loader v-if="loading"></loader>
          <div v-else>
            <div v-for="manager in managers" v-if="manager.generated_money > 0 || manager.predicted_income > 0" @click="manager.clients_expanded = !manager.clients_expanded" style="cursor:pointer;">
              <div class="row client light-hover py-2">
                <div class="col client-name-col align-self-center">
                  <span class="m-badge m-badge--dot" :style="{background: manager.color}"></span>
                  <span style="font-weight: bolder; font-size: 1.25rem;">{{ manager.name }}</span>
                </div>
                <div class="col-auto text-right">
                  {{ manager.predicted_income.toFixed(2) }} €
                </div>
                <div class="col-auto text-right">
                  <b style="font-size: 1.25rem; color: #575962;">
                    {{ manager.generated_money.toFixed(2) }} €
                  </b>
                </div>
              </div>
              <div class="row pl-3" v-for="client in manager.clients" v-if="manager.clients_expanded && (client.generated_money > 0 || client.predicted_income > 0)">
                <div class="col">
                  <div class="row client light-hover py-2">
                    <div class="col client-name-col align-self-center">
                      <span class="m-badge m-badge--dot" :style="{background: manager.color}"></span>
                      <span style="font-weight: bolder; font-size: 1.25rem;">{{ client.name }}</span>
                    </div>
                    <div class="col-auto text-right">
                      {{ client.predicted_income.toFixed(2) }} €
                    </div>
                    <div class="col-auto text-right">
                      <b style="font-size: 1.25rem; color: #575962;">
                        {{ client.generated_money.toFixed(2) }} €
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Colors from './../../components/colors'

  export default {
    props: [
      'startDate',
      'endDate'
    ],
    created() {
      this.axios.get('currencies').then(response => {
        this.currencies = response.data
      })

      this.load()

    },
    data() {
      return {
        managers: [],
        loading: true,
        currencies: null,
      }
    },
    watch: {
      startDate: function () {
        this.load()
      },
      endDate: function () {
        this.load()
      }
    },
    methods: {
      load() {
        this.loading = true
        const data = {
          startDate: this.startDate,
          endDate: this.endDate
        }

        let colors = new Colors();

        this.axios.get('reports/top/client-managers', {params: data})
          .then(res => {
            this.managers = _.reverse(_.sortBy(res.data, 'generated_money'))

            _.each(this.managers, m => {
              m.color = colors.getRandomColor()
              m.clients = _.reverse(_.sortBy(m.clients, 'generated_money'))
            })

            this.loading = false
          })
          .catch(error => {
          })
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/reports/TopClientManagers.vue